import { useQuery } from '@tanstack/react-query';
import { queryKeyFactory } from 'utils/query-client';
import { loaders } from './admin-companies.loaders';
import { converters } from './admin-companies.converters';

export const adminCompaniesKeys = queryKeyFactory('admin-companies');

export const useAdminCompanies = (clientId: string) => {
  return useQuery({
    queryKey: adminCompaniesKeys.list(clientId),
    queryFn: () => loaders.getCompanies({ clientId }),
    select: converters.getCompanies,
    enabled: !!clientId,
  });
};

export const useAdminCompany = (
  companyId: string,
  options: { enabled?: boolean } = {},
) => {
  return useQuery({
    queryKey: adminCompaniesKeys.detail(companyId),
    queryFn: () => loaders.getCompany({ companyId }),
    select: converters.getCompany,
    enabled: options.enabled,
  });
};
